import { sentryQabConfig } from './sentryConfig';

export const sentryConfigActivationFreeCover = {
  ...sentryQabConfig,
  dsn: 'https://e5cd01260524defca4eb22cdaec01a8a@o207017.ingest.sentry.io/4505979571732480',
};
